import { adminComponents } from './admin.js';
import { presetCategoryComponents } from './preset-category.js';
import { presetComponents } from './preset.js';
import { recipeComponents } from './recipe.js';
export const adminGeneratedComponents = [
    ...adminComponents,
    ...presetComponents,
    ...presetCategoryComponents,
    ...recipeComponents
];

//# sourceMappingURL=index.js.map